import React from 'react'
import { Button, InputNumber, Modal } from 'antd'
import { BASE_URL_IMAGE_PROGRAM } from '../../../../utils'
import styles from './InfoProgram.module.css'

const BulkPurchaseModal = ({
  visible,
  programName,
  cover,
  quantity,
  whatsappUrl,
  onCancel,
  onQuantityChange,
}) => {
  return (
    <Modal centered visible={visible} footer={null} onCancel={onCancel}>
      <div className={styles.bulkPurchaseModal}>
        <img
          className={styles.bulkPurchaseImage}
          src={`${BASE_URL_IMAGE_PROGRAM}/${cover}`}
          alt={programName}
        />
        <p className={styles.bulkPurchaseTitle}>{programName}</p>
        <div className={styles.bulkPurchaseQuantity}>
          <p>Jumlah</p>
          <InputNumber
            min={1}
            value={quantity}
            onChange={(value) => onQuantityChange(value || 1)}
          />
        </div>
        <Button
          className={`btn btn-primary ${styles.bulkPurchaseBuyBtn}`}
          href={whatsappUrl}
          target="_blank"
          rel="noreferrer">
          Beli
        </Button>
      </div>
    </Modal>
  )
}

export default BulkPurchaseModal
